export enum REQUEST_TYPES {
	ACTIVATE_EMAIL_ACCOUNT = 'ACTIVATE_EMAIL_ACCOUNT',

}
